import { Icon, Text } from "@chakra-ui/react";
import React from "react";
import { Box, HStack } from "@chakra-ui/layout";
import { Select } from "@chakra-ui/select";
import { Input } from "@chakra-ui/input";
import { Button, ButtonGroup } from "@chakra-ui/button";
import {
  HiChevronDoubleLeft,
  HiChevronDoubleRight,
  HiChevronLeft,
  HiChevronRight,
} from "react-icons/hi";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

const Pagination = ({
  gotoPage,
  previousPage,
  nextPage,
  canPreviousPage,
  canNextPage,
  pageIndex,
  pageOptions,
  pageSize,
  setPageSize,
  pageCount,
  ...props
}) => {
  return (
    <HStack justifyContent="space-between" {...props}>
      <ArrowButtons
        gotoPage={gotoPage}
        canPreviousPage={canPreviousPage}
        previousPage={previousPage}
        nextPage={nextPage}
        canNextPage={canNextPage}
        pageCount={pageCount}
      />
      <HStack spacing={4}>
        <HStack>
          <Text>
            Page{" "}
            <Text as="strong">
              {`${pageIndex + 1} of ${pageOptions.length} `}{" "}
            </Text>
            {/* | Go to page: */}
          </Text>
          {/* <Input
            type="number"
            w={12}
            textAlign="center"
            flex={1}
            defaultValue={pageIndex + 1}
            onChange={(e) => {
              gotoPage(e.target.value ? Number(e.target.value) - 1 : 0);
            }}
          /> */}
        </HStack>
        <Box>
          <PageSelector pageSize={pageSize} setPageSize={setPageSize} />
        </Box>
      </HStack>
    </HStack>
  );
};
export default Pagination;

const PageSelector = ({ pageSize, setPageSize }) => {
  return (
    <Select
      value={pageSize}
      onChange={(e) => setPageSize(Number(e.target.value))}
    >
      {[10, 20, 30, 40, 50].map((pageSize) => (
        <option key={pageSize} value={pageSize}>
          Show {pageSize}
        </option>
      ))}
    </Select>
  );
};

const ArrowButtons = ({
  gotoPage,
  canPreviousPage,
  previousPage,
  nextPage,
  canNextPage,
  pageCount,
}) => {
  return (
    <ButtonGroup isAttached variant="outline">
      <Button
        onClick={() => gotoPage(0)}
        disabled={!canPreviousPage}
        isDisabled={!canPreviousPage}
        borderColor="gray.200"
      >
        <Icon as={HiChevronDoubleLeft} />
      </Button>
      <Button
        onClick={previousPage}
        disabled={!canPreviousPage}
        isDisabled={!canPreviousPage}
        borderColor="gray.200"
      >
        <Icon as={HiChevronLeft} />
      </Button>
      <Button
        onClick={nextPage}
        isDisabled={!canNextPage}
        disabled={!canNextPage}
        borderColor="gray.200"
      >
        <Icon as={HiChevronRight} />
      </Button>
      <Button
        onClick={() => gotoPage(pageCount - 1)}
        disabled={!canNextPage}
        isDisabled={!canNextPage}
        borderColor="gray.200"
      >
        <Icon as={HiChevronDoubleRight} />
      </Button>
    </ButtonGroup>
  );
};
